import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import data from "../data";
import Navbar from "../component/common/Navbar";
import Footer from "../component/common/Footer";
import PageHero from "../component/common/PageHero";
import SingleCourseCard from "../component/courses/SingleCourseCard";
import styles from "./SingleCourse.module.css";

const SingleCourse = () => {
  const [course, setCourse] = useState([]);
  const { id } = useParams();

  const fetchCourse = () => {
    const singleCourse = data.filter((item) => item.id === Number(id));
    setCourse(singleCourse);
  };

  useEffect(() => {
    fetchCourse();
  }, []);

  return (
    <div>
      <Navbar />
      <PageHero
        title={
          <Link className={styles.title} to="/courses">
            Courses <span>/</span>
          </Link>
        }
        subtitle={
          <span className={styles.subtitle}>
            {course.map((item) => item.title)}
          </span>
        }
      />
      <div className="section">
        <div className={styles.backToBtn}>
          <Link to="/courses" className="primary-btn">
            Back To Courses
          </Link>
        </div>
        <div className="section">
          {course.map((item) => {
            return (
              <div key={item.id} className={styles.courseContainer}>
                <SingleCourseCard course={course} />
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SingleCourse;
